<div class='col'>
  <ng-container *ngIf='value === 0'><mat-icon class='text-info'>trending_flat</mat-icon></ng-container>
  <ng-container *ngIf='value > 0'><mat-icon class='text-success'>trending_up</mat-icon></ng-container>
  <ng-container *ngIf='value < 0'><mat-icon class='text-danger'>trending_down</mat-icon></ng-container>
</div>
